/**
 *
 */
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCodeTextBoxSwitching from '@/components/DdCodeTextBoxSwitching'
import DdDataTable from '@/components/DdDataTable'
import DdDateBox from '@/components/DdDateBox'
import DdDialog from '@/components/DdDialog'
import DdDropDown from '@/components/DdDropDown'
import DdEditDialog from '@/components/DdEditDialog'
import DdFooterButton from '@/components/DdFooterButton'
import DdIconButton from '@/components/DdIconButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNumericBox from '@/components/DdNumericBox'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTimeBox from '@/components/DdTimeBox'
import DdTextBox from '@/components/DdTextBox'
import DdTextBoxPlaceHolderFree from '@/components/DdTextBoxPlaceHolderFree'
import DdTextBoxSwitching from '@/components/DdTextBoxSwitching'
import DdRadioButton from '@/components/DdRadioButton'
import DdRowCountBox from '@/components/DdRowCountBox'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
// import google from '@/ddv2.library/utils/google'
import indexeddb from '@/ddv2.library/indexeddb'

import flowMixin from '@/mixins/flowMixins'
// import complements from '@/rahmen/complement'
import controls from '@/rahmen/controls'
import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'

import { mapGetters } from 'vuex'

export default {
  name: 'HacchuEdit',
  mixins: [flowMixin],
  data: () => ({
    meisaiHeaders: [
      { text: '#', value: 'hacchuMeisaiNo', width: '2%', sortable: false },
      { text: '作業予定日', value: 'sagyoYoteiYmdString', width: '5%', sortable: false },
      { text: '荷主', value: 'ninushiNm', width: '10%', sortable: false },
      { text: '発地', value: 'hatsuchiNm', width: '8%', sortable: false },
      { text: '発日付', value: 'hatsuchiYmdString', width: '5%', sortable: false, align: 'center' },
      { text: '発時刻', value: 'hatsuchiHmsString', width: '4%', sortable: false, align: 'center' },
      { text: '卸先', value: 'oroshisakiNm', width: '10%', sortable: false },
      { text: '着地', value: 'chakuchiNm', width: '8%', sortable: false },
      { text: '着日付', value: 'chakuchiYmdString', width: '5%', sortable: false, align: 'center' },
      { text: '着時刻', value: 'chakuchiHmsString', width: '4%', sortable: false, align: 'center' },
      { text: '金額計', value: 'seikyu_kingaku', width: '8%', sortable: false, align: 'right' },
      { text: '操作', value: 'actions', width: '8%', sortable: false },
      { text: '品目展開', value: 'data-table-expand', width: '6%', sortable: false }
    ],
    hinmokuHeaders: [
      { text: 'MNo.', value: 'hacchuMeisaiNo', width: '5%', sortable: false, filterable: true, align: ' d-none' },
      { text: '品目番号', value: 'hacchuHinmokuNo', width: '5%', sortable: false, filterable: false },
      { text: '品目種別', value: 'hinmokuSbtNm', width: '10%', sortable: false, filterable: false },
      { text: '商品名', value: 'hinmeiNm', width: '15%', sortable: false, filterable: false },
      { text: '数量', value: 'hacchuSuryo', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '単位', value: 'unitKbnNm', width: '7%', sortable: false, filterable: false, align: 'center' },
      { text: '重量', value: 'hacchuJuryo', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '才数', value: 'hacchuSaisu', width: '7%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '単価', value: 'tanka', width: '8%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '金額', value: 'kingaku', width: '8%', sortable: false, filterable: false, align: 'right', class: 'able-edit' },
      { text: '操作', value: 'actions', width: '13%', sortable: false }
    ],
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    IsReadOnly: false,
    id: 0,
    rec: {
      hacchuMeisai: [],
      hacchuKingaku1: {}
    },
    isShowMeisaiDialog: false,
    meisaiDialogTarget: {
      hacchuKingaku1: {},
      hacchuHinmoku: [],
      ninushi: {},
      hatsuchi: {},
      oroshisaki: {},
      chakuchi: {}
    },
    isShowHinmokuDialog: false,
    hinmokuDialogTarget: {
      hacchuKingaku1: {},
      hinmei: {},
      hinmokuSbtMst: {},
      unitKbnMst: {}
    },
    hinmeiSwitch: false,
    currentMstKingaku: {}
  }),
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdDataTable,
    DdDateBox,
    DdDialog,
    DdDropDown,
    DdEditDialog,
    DdFooterButton,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSubHeader,
    DdSwitch,
    DdTimeBox,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTextBoxSwitching,
    DdRadioButton,
    DdRowCountBox
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hinmeiList: 'DDMasters/mstHinmei',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd'
    }),
    filterdOfukuKubunList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF052')
    },
    filterdTaniKubunList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    filterdHinmokuShubetsuKubunList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    filterdShashuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filterdMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstHinmei () {
      if (this.rec.torihikisakiId !== '') {
        const a = this.torihikisakiList.find(l => {
          return l.id === this.rec.torihikisakiId
        })
        if (a) {
          return this.hinmeiList.filter(l => {
            return l.torihikisakiCd === a.torihikisakiCd
          }).map((elem) => {
            elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
            elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
            return elem
          })
        }
      }
      return []
    },
    filterdMstHacchakuchi () {
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstJinin () {
      return this.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filterdMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    isTorihikisakiUsable () {
      const currentMaxNo = Math.max((this.rec.hacchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.hacchuMeisai.map(m => m.hacchuMeisaiNo)))
      console.log('HacchuEdit', 'isTorihikisakiUsable', currentMaxNo)
      if (currentMaxNo !== 0) {
        return false
      }
      return true
    },
    isHacchuMeisaiUsable () {
      console.log('HacchuEdit', 'isHacchuMeisaiUsable', this.rec.torihikisakiId)
      if (!this.rec.hacchusakiId) {
        return false
      }
      return true
    },
    isMapUsable () {
      // 明細レコードが存在しない場合
      if (this.rec === {}) { return false }
      if (this.rec.juchuMeisai === undefined) { return false }
      if (this.rec.juchuMeisai.length < 1) { return false }

      return true
    },
    detailAmount () {
      // 明細レコードが存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.hacchuMeisai === undefined) { return 0 }

      let amount = 0

      // 集計
      this.rec.hacchuMeisai.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(target.seikyu_kingaku)
      }).map(k => {
        // 金額項目を数値に変換
        return parseInt(k.seikyu_kingaku, 10)
      }).forEach(k => {
        amount += k
        console.log('HacchuEdit', 'forEach', amount)
      })

      return amount
    },
    detailMeisaiAmount () {
      const target = this.meisaiDialogTarget.hacchuKingaku1
      if (target === [] || target === null || target === undefined) { return 0 }

      const l = this.convertKingakuItemsToArray(target)

      if (l.length === 0) { return 0 }
      const amount = l.reduce((a, c) => a + c)
      return amount
    },
    formTitle () {
      if (this.hinmokuDialogTarget === {}) { return '登録' }
      return '更新'
    }
    /*
    currentMstKingaku () {
      if (this.rec.hacchusakiId === 0) { return {} }
      const mt = this.hacchusakiList.find((t) => {
        return t.mstTorihikisakiId === this.rec.hacchusakiId
      })
      if (mt === undefined || mt === null) { return {} }
      console.log('HacchuEdit.currentMstKingaku', mt)
      const mk = this.kingakuList.find((k) => {
        return k.id === mt.mstKingakuId
      })
      if (mk === undefined || mk === null) { return {} }
      return mk
    }
    */
  },
  created () {
    this.id = this.$route.params.id
    this.id = (this.id === '0') ? 0 : this.id
  },
  mounted () {
    this.initialize()
  },
  methods: {
    /**
     * 初期化処理
     */
    initialize () {
      console.log('HacchuEdit', 'initialize', this.id)
      const self = this
      const option = {
        loadMasters: [
          'msttorihikisaki',
          'msteigyosho',
          'msthinmei',
          'msthacchakuchi',
          'vwcmsteigyoshojininlist',
          'vwcmstsharyo',
          'msyskubun',
          'mstshubetsu'
        ],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('HacchuEdit', 'initializeInputPromise')
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('HacchuEdit', 'savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('HacchuEdit', 'existsIdMethod', self.id)
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('HacchuEdit', 'settingButtonStatePromise', kengen)
            resolve()
          })
        }
      }
      console.info('HacchuEdit', 'call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    /**
     * 画面表示データ取得
     */
    fetchData () {
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/TrHacchuKihon/FindWithChildren?id=${this.id}`)
          .then((data) => {
            console.log('HacchuEdit', 'fetchData', data.payload)
            const x = data.payload
            // 編集
            this.rec = x
            // 基準日設定
            this.baseYmd = x.hacchuYmdString
            // 明細情報編集

            this.calculateMeisaiRows()
            resolve()
          })
      })
    },
    // viewMixins の validateAll を上書き
    validateAll (refs, prefix) {
      console.log('HacchuEdit', 'validateAll', refs, prefix)
      let result
      const ctrls = Object.keys(refs)
      ctrls.forEach(c => {
        if ((prefix === undefined && !c.includes('-')) || (prefix !== undefined && c.indexOf(prefix) === 0)) {
          console.log('HacchuEdit', 'validateAll', 'forEach', c)
          let targets = []
          if (Array.isArray(refs[c])) {
            targets = targets.concat(refs[c])
          } else {
            targets.push(refs[c])
          }
          targets.forEach(t => {
            if (t === undefined) { return }
            if (t[controls.VALIDATE_METHOD] === undefined) { return }
            if (t[controls.GET_INVALID_METHOD] === undefined) { return }
            t[controls.VALIDATE_METHOD]()
            const res = t[controls.GET_INVALID_METHOD]()
            if (res === undefined) { return }
            result = res
          })
        } else {
          console.log('HacchuEdit', 'validateAll', 'forEach', 'skip', c)
        }
      })
      console.log('HacchuEdit', 'validateAll', result)
      return result === undefined
    },
    onMeisaiEditClosed (e, row) {
      if (!e) { return false }

      // TODO 明細行の更新時
    },
    onHinmokuEditClosed (e, row, isRecalc) {
      const recalc = isRecalc || false
      console.log('HacchuEdit', e, row)
      if (!e) { return false }
      if (recalc) {
        const suryo = row.hacchuSuryo || 0
        const tanka = row.tanka || 0
        console.log('HacchuEdit', suryo, tanka)
        if (!window.isFinite(suryo) || !window.isFinite(tanka)) { return }
        row.kingaku = parseInt(suryo, 10) * parseInt(tanka, 10)

        this.$set(row, 'kingaku', row.kingaku)

        console.log('HacchuEdit', row.kingaku, this.rec)
      }

      this.calcMeisaiRows(row.trHacchuMeisaiId)
    },
    calcMeisaiRows (id) {
      this.redrawMeisaiRow(id)
    },
    copyMeisaiRow (row) {
      const appendRow = dolly.clone(row)
      const currentMaxNo = Math.max((this.rec.hacchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.hacchuMeisai.map(m => m.hacchuMeisaiNo)))
      console.log('HacchuEdit', appendRow)
      appendRow.id = 0
      appendRow.hacchuMeisaiNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
      appendRow.hacchuHinmoku.forEach(h => {
        h.id = 0
        h.trHacchuMeisaiNo = appendRow.hacchuMeisaiNo
      })
      this.rec.hacchuMeisai.push(appendRow)
    },
    copyHinmokuRow (row, parentRow) {
      console.log('HacchuEdit', 'copyHinmokuRow', row)
      const parent = this.rec.hacchuMeisai.find(m => {
        return m.hacchuMeisaiNo === row.trHacchuMeisaiNo
      }) || parentRow

      const appendRow = dolly.clone(row)
      const currentMaxNo = Math.max((parent.hacchuHinmokuMaxNo ?? 0), Math.max.apply(null, parent.hacchuHinmoku.map(m => m.hacchuHinmokuNo)))
      console.log('HacchuEdit', appendRow)
      appendRow.id = 0
      appendRow.hacchuHinmokuNo = !Number.isNaN(currentMaxNo) ? 1 : currentMaxNo + 1
      parent.hacchuHinmoku.push(appendRow)
      this.redrawMeisaiRow(parent.id)
    },
    moveUpMeisaiRow (row) {
      const index = this.rec.hacchuMeisai.indexOf(row)
      if (index === 0 || index === -1) { return }
      this.rec.hacchuMeisai.splice(
        index - 1,
        2,
        this.rec.hacchuMeisai[index],
        this.rec.hacchuMeisai[index - 1])
    },
    moveUpHinmokuRow (row, parentRow) {
      console.log('HacchuEdit', 'moveUpHinmokuRow', row)
      const parent = this.rec.hacchuMeisai.find(m => {
        return m.hacchuMeisaiNo === row.trHacchuMeisaiNo
      }) || parentRow
      const index = parent.hacchuHinmoku.indexOf(row)
      console.log('HacchuEdit', 'moveUpHinmokuRow', 'index', index)

      if (index === 0 || index === -1) { return }
      parent.hacchuHinmoku.splice(
        index - 1,
        2,
        parent.hacchuHinmoku[index],
        parent.hacchuHinmoku[index - 1])
    },
    moveDownMeisaiRow (row) {
      const index = this.rec.hacchuMeisai.indexOf(row)
      if (index === this.rec.hacchuMeisai.length - 1 || index === -1) { return }
      this.rec.hacchuMeisai.splice(
        index,
        2,
        this.rec.hacchuMeisai[index + 1],
        this.rec.hacchuMeisai[index])
    },
    moveDownHinmokuRow (row, parentRow) {
      console.log('HacchuEdit', 'moveDownHinmokuRow', row)
      const parent = this.rec.hacchuMeisai.find(m => {
        return m.hacchuMeisaiNo === row.trHacchuMeisaiNo
      }) || parentRow
      const index = parent.hacchuHinmoku.indexOf(row)
      console.log('HacchuEdit', 'moveDownHinmokuRow', 'index', index)

      if (index === parent.hacchuHinmoku.length - 1 || index === -1) { return }
      parent.hacchuHinmoku.splice(
        index,
        2,
        parent.hacchuHinmoku[index + 1],
        parent.hacchuHinmoku[index])
    },
    deleteMeisaiRow (row) {
      const index = this.rec.hacchuMeisai.indexOf(row)
      row.delFlg = true
      this.$set(this.rec.hacchuMeisai, index, row)
    },
    deleteHinmokuRow (row, parentRow) {
      console.log('HacchuEdit', 'deleteHinmokuRow', row)
      const parent = this.rec.hacchuMeisai.find(m => {
        return m.hacchuMeisaiNo === row.trHacchuMeisaiNo
      }) || parentRow
      const index = parent.hacchuHinmoku.indexOf(row)

      row.delFlg = true
      parent.hacchuHinmoku.splice(index, 1, row)
    },
    restoreMeisaiRow (row) {
      const index = this.rec.hacchuMeisai.indexOf(row)
      row.delFlg = false
      this.$set(this.rec.hacchuMeisai, index, row)
    },
    restoreHinmokuRow (row, parentRow) {
      console.log('HacchuEdit', 'restoreHinmokuRow', row)
      const parent = this.rec.hacchuMeisai.find(m => {
        return m.hacchuMeisaiNo === row.trHacchuMeisaiNo
      }) || parentRow
      const index = parent.hacchuHinmoku.indexOf(row)

      row.delFlg = false
      parent.hacchuHinmoku.splice(index, 1, row)
    },
    redrawMeisaiRow (id) {
      if (id === undefined) {
        this.$set(this, 'meisaiDialogTarget', dolly.clone(this.meisaiDialogTarget))
        return
      }
      const row = this.rec.hacchuMeisai.find(m => {
        return m.id === id
      })
      const index = this.rec.hacchuMeisai.indexOf(row)
      console.log('HacchuEdit', 'redrawMeisaiRow', id, index)
      if (index === this.rec.hacchuMeisai.length - 1 || index === -1) { return }
      this.rec.hacchuMeisai.splice(
        index,
        1,
        this.rec.hacchuMeisai[index])
    },
    onMeisaiDialogOpenClick (row, isCreate) {
      console.log('HacchuEdit', 'onMeisaiDialogOpenClick', row, isCreate)
      const create = isCreate || false
      this.meisaiDialogTarget = create ? {
        sagyoYoteiYmdString: this.baseYmd,
        hacchuKingaku1: {},
        hacchuHinmoku: [],
        ninushi: {},
        hatsuchi: {},
        oroshisaki: {},
        chakuchi: {}
      } : dolly.clone(row)
      this.isShowMeisaiDialog = true
      console.log('HacchuEdit', 'onMeisaiDialogOpenClick', this.meisaiDialogTarget, this.isShowMeisaiDialog)
    },
    onCloseMeisaiDialogClick (e) {
      this.isShowMeisaiDialog = false
    },
    onMeisaiDialogSave (e) {
      console.log('HacchuEdit', 'onMeisaiDialogSave', this.meisaiDialogTarget)

      const isValid = this.validateAll(this.$refs, 'meisaiDialog')
      console.log('HacchuEdit', 'onMeisaiDialogSave', 'validate', isValid)
      if (!isValid) return

      this.isShowMeisaiDialog = false
      const result = this.meisaiDialogTarget

      if (result !== null) {
        const index = this.rec.hacchuMeisai
          .map(m => m.hacchuMeisaiNo)
          .indexOf(this.meisaiDialogTarget.hacchuMeisaiNo)
        console.log('HacchuEdit', 'onMeisaiDialogSave', 'Index', index)

        // TODO ここで必要な値を設定する
        result.ninushi = result.ninushi || {}
        result.ninushiId = 0
        result.ninushiNm = ''
        if (result.ninushi && result.ninushi.torihikisakiCd !== '') {
          const h = this.torihikisakiList.find(l => {
            return l.torihikisakiCd === result.ninushi.torihikisakiCd
          })
          if (h) {
            result.ninushi = h
            result.ninushiId = h.id
            result.ninushiNm = `${h.torihikisakiCd}:${h.torihikisakiNm}`
          }
        }

        result.hatsuchi = result.hatsuchi || {}
        result.hatsuchiId = 0
        result.hatsuchiNm = ''
        if (result.hatsuchi && result.hatsuchi.hacchakuchiCd !== '') {
          const h = this.hacchakuchiList.find(l => {
            return l.hacchakuchiCd === result.hatsuchi.hacchakuchiCd
          })
          if (h) {
            result.hatsuchi = h
            result.hatsuchiId = h.id
            result.hatsuchiNm = `${h.hacchakuchiCd}:${h.hacchakuchiNm}`
          }
        }

        result.oroshisaki = result.oroshisaki || {}
        result.oroshisakiId = 0
        result.oroshisakiNm = ''
        if (result.oroshisaki && result.oroshisaki.torihikisakiCd !== '') {
          const h = this.torihikisakiList.find(l => {
            return l.torihikisakiCd === result.oroshisaki.torihikisakiCd
          })
          if (h) {
            result.oroshisaki = h
            result.oroshisakiId = h.id
            result.oroshisakiNm = `${h.torihikisakiCd}:${h.torihikisakiNm}`
          }
        }

        result.chakuchi = result.chakuchi || {}
        result.chakuchiId = 0
        result.chakuchiNm = ''
        if (result.chakuchi && result.chakuchi.hacchakuchiCd !== '') {
          const h = this.hacchakuchiList.find(l => {
            return l.hacchakuchiCd === result.chakuchi.hacchakuchiCd
          })
          if (h) {
            result.chakuchi = h
            result.chakuchiId = h.id
            result.chakuchiNm = `${h.hacchakuchiCd}:${h.hacchakuchiNm}`
          }
        }

        if (index === -1) {
          // TODO ここで必要な初期値を設定する
          const currentMaxNo = Math.max((this.rec.hacchuMeisaiMaxNo ?? 0), Math.max.apply(null, this.rec.hacchuMeisai.map(m => m.hacchuMeisaiNo)))
          result.hacchuMeisaiNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
          result.delFlg = false

          result.hacchuHinmoku.forEach(h => {
            h.trHacchuMeisaiNo = result.hacchuMeisaiNo
          })

          console.log('HacchuEdit', 'onMeisaiDialogSave', 'push', result)
          this.rec.hacchuMeisai.push(result)
        } else {
          console.log('HacchuEdit', 'onMeisaiDialogSave', 'splice', result)
          this.rec.hacchuMeisai.splice(index, 1, result)
        }
      }

      this.isShowMeisaiDialog = false
      this.meisaiDialogTarget = {
        hacchuKingaku1: {},
        hacchuHinmoku: [],
        ninushi: {},
        hatsuchi: {},
        oroshisaki: {},
        chakuchi: {}
      }
      this.calculateMeisaiRows()
      this.calcMeisaiRows(result.trHacchuMeisaiId)
    },
    onHinmokuDialogOpenClick (row, isCreate) {
      console.log('HacchuEdit', 'onHinmokuDialogOpenClick', row, isCreate)
      const create = isCreate || false
      this.hinmokuDialogTarget = create ? {
        hacchuKingaku1: {},
        hinmei: {},
        hinmokuSbtMst: {},
        unitKbnMst: {}
      // } : dolly.clone(row)
      } : row
      this.isShowHinmokuDialog = true
      console.log('HacchuEdit', 'onHinmokuDialogOpenClick', this.hinmokuDialogTarget, this.isShowHinmokuDialog)
    },
    onCloseHinmokuDialogClick (e) {
      this.isShowHinmokuDialog = false
    },
    onHinmokuDialogSave (parentRow) {
      console.log('HacchuEdit', 'onHinmokuDialogSave', this.hinmokuDialogTarget, parentRow)

      const isValid = this.validateAll(this.$refs, 'hinmokuDialog')
      console.log('HacchuEdit', 'onHinmokuDialogSave', 'validate', isValid)
      if (!isValid) return

      this.isShowHinmokuDialog = false
      const result = this.hinmokuDialogTarget

      if (result !== null) {
        const parent = this.rec.hacchuMeisai.find(m => {
          return m.hacchuMeisaiNo === result.trHacchuMeisaiNo
        }) || parentRow
        const row = parent.hacchuHinmoku.find(h => {
          return h.hacchuHinmokuNo === result.hacchuHinmokuNo
        })
        const index = parent.hacchuHinmoku.indexOf(row)
        console.log('HacchuEdit', 'onHinmokuDialogSave', 'DEBUG', 'Index', index)

        // TODO ここで必要な値を設定する
        result.trHacchuMeisaiNo = parent.hacchuMeisaiNo

        result.hinmei = result.hinmei || {}
        result.mstHinmeiId = 0
        result.hinmeiNm = ''
        if (result.hinmei && result.hinmei.hinmeiCd !== '') {
          if (this.rec.torihikisakiId !== '') {
            const a = this.torihikisakiList.find(l => {
              return l.id === this.rec.torihikisakiId
            })
            if (a) {
              const h = this.hinmeiList.find(l => {
                return l.torihikisakiCd === a.torihikisakiCd && l.hinmeiCd === result.hinmei.hinmeiCd
              })
              if (h) {
                result.hinmei = h
                result.mstHinmeiId = h.id
                result.hinmeiNm = `${h.hinmeiCd}:${h.hinmeiNm}`
              }
            }
          }
        }

        result.hinmokuSbtMst = result.hinmokuSbtMst || {}
        result.hinmokuSbtNm = ''
        if (result.hinmokuSbt !== '') {
          const h = this.shubetsuList.find(l => {
            return l.sbtShuruiCd === 'GVIJ02' && l.sbtCd === result.hinmokuSbt
          })
          if (h) {
            result.hinmokuSbtMst = h
            result.hinmokuSbtNm = `${h.sbtCd}:${h.sbtNm}`
          }
        }

        result.unitKbnMst = result.unitKbnMst || {}
        result.unitKbnNm = ''
        if (result.unitKbn !== '') {
          const h = this.shubetsuList.find(l => {
            return l.sbtShuruiCd === 'SVI001' && l.sbtCd === result.unitKbn
          })
          if (h) {
            result.unitKbnMst = h
            result.unitKbnNm = `${h.sbtCd}:${h.sbtNm}`
          }
        }

        result.hacchuKingaku1.kihonUnchin = result.kingaku

        if (index === this.rec.hacchuMeisai.length - 1 || index === -1) {
          // TODO ここで必要な初期値を設定する
          const currentMaxNo = Math.max((parent.hacchuHinmokuMaxNo ?? 0), Math.max.apply(null, parent.hacchuHinmoku.map(m => m.hacchuHinmokuNo)))
          result.hacchuHinmokuNo = !window.isFinite(currentMaxNo) ? 1 : currentMaxNo + 1
          result.delFlg = false

          console.log('HacchuEdit', 'onHinmokuDialogSave', 'push', result)
          parent.hacchuHinmoku.push(result)
        } else {
          console.log('HacchuEdit', 'onHinmokuDialogSave', 'splice', result)
          parent.hacchuHinmoku.splice(index, 1, result)
        }
      }

      this.isShowHinmokuDialog = false
      this.hinmokuDialogTarget = {
        hacchuKingaku1: {},
        hinmei: {},
        hinmokuSbtMst: {},
        unitKbnMst: {}
      }
      this.calcMeisaiRows(result.trHacchuMeisaiId)
    },
    onDialogKingakuBlur (refObj) {
      this.$set(this.meisaiDialogTarget, 'hacchuKingaku1', refObj)
    },
    calculateMeisaiRows () {
      console.log('HacchuEdit', 'calculateMeisaiRows', this.rec.hacchuMeisai)
      this.rec.hacchuMeisai.forEach(m => {
        const l = this.convertKingakuItemsToArray(m.hacchuKingaku1)
        if (l.length === 0) { return 0 }
        const amount = l.reduce((a, c) => a + c)

        const index = this.rec.hacchuMeisai.indexOf(m)
        m.seikyu_kingaku = amount
        this.rec.hacchuMeisai.splice(index, 1, m)
      })
      console.log('HacchuEdit', 'calculateMeisaiRows', this.rec.hacchuMeisai)
    },
    convertKingakuItemsToArray: function (target) {
      const props = [
        'kihonUnchin',
        'jikanWarimashiKingaku',
        'kyoriWarimashiKingaku',
        'keisuWarimashiKingaku',
        'nenryoWarimashiKingaku',
        'hiwayPrice',
        'userKingakuKazei1',
        'userKingakuKazei2',
        'userKingakuKazei3',
        'userKingakuKazei4',
        'userKingakuKazei5',
        'userKingakuKazei6',
        'userKingakuKazei7',
        'userKingakuKazei8',
        'userKingakuKazei9',
        'userKingakuKazei10',
        'userKingakuHikazei1',
        'userKingakuHikazei2',
        'userKingakuHikazei3',
        'userKingakuHikazei4',
        'userKingakuHikazei5',
        'userKingakuHikazei6',
        'userKingakuHikazei7',
        'userKingakuHikazei8',
        'userKingakuHikazei9',
        'userKingakuHikazei10',
        'userKingakuUchizei1',
        'userKingakuUchizei2',
        'userKingakuUchizei3',
        'userKingakuUchizei4',
        'userKingakuUchizei5',
        'userKingakuUchizei6',
        'userKingakuUchizei7',
        'userKingakuUchizei8',
        'userKingakuUchizei9',
        'userKingakuUchizei10'
      ]

      const l = props.filter(p => {
        return window.isFinite(target[p])
      }).map(p => {
        return Number.parseFloat(target[p])
      }).map(p => {
        return Number.isNaN(p) ? 0 : p
      })
      return l
    },
    /**
     * 戻るボタンクリック
     */
    onReturnClick () {
      console.log('HacchuEdit', 'onReturnClick')
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.transitionBack(opt)
    },
    /**
     * キャンセルボタンクリック
     */
    onCancelClick () {
      console.log('HacchuEdit', 'onCancelClick')
      const self = this
      const opt = {
        restoreInputsPromise: self.fetchData
      }
      this.cancelInputs(opt)
    },
    /**
     * 削除ボタンクリック
     */
    onDeleteClick () {
      console.log('HacchuEdit', 'onDeleteClick')
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/TrHacchuKihon/DeleteWithChildren?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.delete(opt)
    },
    /**
     * 新規ボタンクリック
     */
    onCreateClick () {
      console.log('HacchuEdit', 'onCreateClick')
      this.id = 0
      this.transition(0, { id: 0 }, this.initialize)
    },
    /**
     * 複写ボタンクリック
     */
    onCopyClick () {
      console.log('HacchuEdit', 'onCopyClick')
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
        }
      }
      this.copyInputs(opt)
    },
    /**
     * 注文受書出力ボタンクリック
     */
    onOrderReportClick () {
      console.log('HacchuEdit', 'onOrderReportClick')
    },
    /**
     * 保存ボタンクリック
     */
    onSaveClick () {
      console.log('HacchuEdit', 'onSaveClick')
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.rec.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.transition(0, { id: id }, self.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        judgeKeyChangedMethod: function (data) {
          // return data.hacchakuchiCd !== this.rec.hacchakuchiCd
          // TODO: ユニークキーの変更判定
          return false
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.rec.id === undefined || this.rec.id === 0) {
        console.log('HacchuEdit', 'onSaveClick', 'UpdateWithChildren', this.rec.id)
        // f = this.HttpClient.post('/api/v1/TrHacchuKihon/CreateWithChildren', this.rec)
        f = this.HttpClient.put(`/api/v1/TrHacchuKihon/UpdateWithChildren?id=${0}`, this.rec)
      } else {
        console.log('HacchuEdit', 'onSaveClick', 'UpdateWithChildren', this.rec.id)
        f = this.HttpClient.put(`/api/v1/TrHacchuKihon/UpdateWithChildren?id=${this.rec.id}`, this.rec)
      }
      return f
    },
    registerValidate () {
      // TODO 登録・更新時クライアント側Validate
      return true
    },
    deleteValidate: function () {
      // TODO 削除時クライアント側Validate
      return true
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = !this.hinmeiSwitch
    },
    changeHacchuInfo: function () {
      if (this.rec.hacchusakiId === 0) {
        this.currentMstKingaku = {}
      } else {
        this.HttpClient
          .get(`/api/v1/MstKingaku/FindByType?id=${this.rec.hacchusakiId}&kinKbn=${3}`)
          .then((data) => {
            this.currentMstKingaku = data.payload
          })
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      // 基準日初期値設定
      this.baseYmd = date.getCurrentDate()
      const x = {
        hacchuEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, this.baseYmd).id : null,
        hacchuYmdString: this.baseYmd,
        hacchusakiKbn: '1',
        ikkatsuShiharaiFlg: true,
        hacchuMeisai: [],
        hacchuKingaku1: {}
      }
      this.rec = x
    }
  }
}
